import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.jpg'
import _imports_1 from '@/assets/home/videoPlay.png'


const _withScopeId = n => (_pushScopeId("data-v-25270ac6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "logo_container",
  "data-aos": "fade-down",
  "data-aos-duration": "800"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_3 = {
  "data-aos": "fade-up",
  "data-aos-duration": "1000"
}
const _hoisted_4 = {
  id: "home_play_bg",
  "data-aos": "zoom-in",
  "data-aos-delay": "200"
}
const _hoisted_5 = {
  id: "home_words",
  "data-aos": "fade-up",
  "data-aos-delay": "400"
}
const _hoisted_6 = {
  key: 1,
  id: "vide_content",
  controls: "",
  autoplay: "true",
  name: "media"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "home_footer",
  "data-aos": "fade-up",
  "data-aos-offset": "50"
}, [
  /*#__PURE__*/_createElementVNode("div", { id: "home_footer_content" }, "分享自然真味"),
  /*#__PURE__*/_createElementVNode("div", { id: "home_footer_content" }, "不负农人苦心"),
  /*#__PURE__*/_createElementVNode("hr", { id: "home_footer_sep" }),
  /*#__PURE__*/_createElementVNode("div", { id: "home_footer_content" }, "发现植物的力量"),
  /*#__PURE__*/_createElementVNode("div", { id: "home_footer_content" }, "发现植物的味道")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Outerbar = _resolveComponent("Outerbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.showBg)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: "home_content",
            style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgURL})` })
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                id: "play_img",
                alt: "play",
                src: _imports_1,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.doPlayVideo && _ctx.doPlayVideo(...args)))
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.words, (word, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  id: "home_word",
                  key: `word_${index}`
                }, _toDisplayString(word), 1))
              }), 128))
            ])
          ], 4))
        : (_openBlock(), _createElementBlock("video", _hoisted_6, [
            _createElementVNode("source", {
              src: _ctx.videoURL,
              type: "video/mp4"
            }, null, 8, _hoisted_7)
          ]))
    ]),
    _hoisted_8,
    _createVNode(_component_Outerbar)
  ]))
}